export const PARENT_INVITATION_TARGET_MODES = {
    allEligibleContacts: 1,
    selectedYearGroups: 2
};

export const PARENT_INVITATION_TARGET_MODE_OPTIONS = [
    {
        value: PARENT_INVITATION_TARGET_MODES.allEligibleContacts,
        label: 'All eligible contacts'
    },
    {
        value: PARENT_INVITATION_TARGET_MODES.selectedYearGroups,
        label: 'Selected year groups'
    }
];
